<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="famillePlanAlimentaireSvc"></yo-generic-datagrid-pn>
